export default __webpack_public_path__ + "src/assets/unstoppable.6aae309d300121d0c6d2e0c166323fdc.svg";